import React from 'react';
import { Provider } from 'mobx-react';
import Routes from './Routes';

import * as api from '../actions/api';
import * as maintenanceApi from './Maintenance/api';
import * as idaqApi from './IDaq/api';
import * as sysConfigApi from './SystemConfiguration/api';

import Aggregationstore from '../stores/AggregationStore';
import DaqLocationStore from '../stores/DaqLocationStore';
import DataOriginParameterStore from '../stores/DataOriginParameterStore';
import DataOriginParameterTemplateStore from '../stores/DataOriginParameterTemplateStore';
import DataOriginStore from '../stores/DataOriginStore';
import DataSeriesStore from '../stores/DataSeriesStore';
import DataSourceStore from '../stores/DataSourceStore';

import DaqProcessorStore from '../stores/DaqProcessorStore';

import FolderStore from '../stores/FolderStore';

import InventoryManufacturerStore from '../stores/Inventory/InventoryManufacturerStore';
import InventoryProductStore from '../stores/Inventory/InventoryProductStore';
import InventoryItemStore from '../stores/Inventory/InventoryItemStore';
import InventorySupplierStore from '../stores/Inventory/InventorySupplierStore';
import InventoryPcategoryStore from '../stores/Inventory/InventoryPcategoryStore';

import MapStore from '../stores/MapStore';
import TransferStore from '../stores/TransferStore';
import MetaDataStore from '../stores/MetaDataStore';
import MetaDataTemplateStore from '../stores/MetaDataTemplateStore';
import MonitoringStore from '../stores/MonitoringStore';
import ParameterStore from '../stores/ParameterStore';
import ParameterTypeStore from '../stores/ParameterTypeStore';
import ParameterUnitStore from '../stores/ParameterUnitStore';
import PermissionStore from '../stores/PermissionStore';
import ParameterPermissionStore from '../stores/ParameterPermissionStore';
import StationPermissionStore from '../stores/StationPermissionStore';
import RolePermissionStore from '../stores/RolePermissionStore';
import QCRuleStore from '../stores/QCRuleStore';
import QCCheckStore from '../stores/QCCheckStore';
import QCTypeStore from '../stores/QCTypeStore';
import RequestStore from '../stores/RequestStore';
import RoleStore from '../stores/RoleStore';
import StationStore from '../stores/StationStore';
import StationFtpStore from '../stores/StationFtpStore';
import TagStore from '../stores/TagStore';
import UiStore from '../stores/UiStore';
import UnitStore from '../stores/UnitStore';
import UserStore from '../stores/UserStore';
import UserPreferenceStore from '../stores/UserPreferenceStore';

import TicketStore from '../stores/Maintenance/Ticket/TicketStore';
import TicketStatusStore from '../stores/Maintenance/Ticket/TicketStatusStore';
import TicketReasonStore from '../stores/Maintenance/Ticket/TicketReasonStore';
import TicketActionStore from '../stores/Maintenance/Ticket/TicketActionStore';

import WorkOrderRouteStore from '../stores/Maintenance/WorkOrder/WorkOrderRouteStore'
import WorkOrderStore from '../stores/Maintenance/WorkOrder/WorkOrderStore'
import WorkOrderStatusStore from '../stores/Maintenance/WorkOrder/WorkOrderStatusStore';
import PriorityStore from '../stores/Maintenance/WorkOrder/PriorityStore';
import MaintenanceTypeStore from '../stores/Maintenance/WorkOrder/MaintenanceTypeStore';
import DataExportStore from "../stores/DataDelivery/DataExportStore";
import RawDataExportStore from "../stores/DataDelivery/RawDataExportStore";

import QCFlagStore from "../stores/QCFlagStore";

import HydrologyStore from '../stores/HydrologyStore';
import HQCStore from "../stores/HQCStore";
import IDaqImageSourceStore from "../stores/IDaq/ImageSourceStore";
import IDaqImageSourceDeviceStore from "../stores/IDaq/ImageSourceDeviceStore";
import StationImageStore from "../stores/IDaq/StationImageStore";
import ImageTagStore from "../stores/IDaq/ImageTagStore";
import { stationInventory } from "../actions/api";

import ImageStore from "../stores/ImageStore";

import SystemStore from '../stores/SystemConfiguration/SystemStore';
import HydroMeteoStore from '../stores/HydroMeteoStore';

import LocationStore from '../stores/Location/LocationStore';
import LocationTypeStore from '../stores/Location/LocationTypeStore';
import StationTypeStore from '../stores/StationTypeStore';
import ReportingTemplateStore from '../stores/SystemConfiguration/ReportingTemplateStore';
import ReportingTemplateHeaderStore from '../stores/SystemConfiguration/ReportingTemplateHeaderStore';

import RatingEquationStore from '../stores/Hydrology/RatingEquationStore';
import TopicStore from '../stores/Maintenance/Survey/TopicStore';
import TemplateStore from '../stores/Maintenance/Survey/TemplateStore';
import SurveyStore from '../stores/Maintenance/Survey/SurveyStore';
import EventTypeStore from '../stores/Maintenance/Event/EventTypeStore';
import EventStore from '../stores/Maintenance/Event/EventStore';

import ServerStore from '../stores/SystemConfiguration/ServerStore';
import IdaqExportStore from '../stores/DataDelivery/IdaqExportStore';

const aggregationStore = new Aggregationstore(api.aggregation);
const requestStore = new RequestStore(api.request);
const qcCheckStore = new QCCheckStore(api.qcCheck);
const qcTypeStore = new QCTypeStore(api.qcType);
const qcFlagStore = new QCFlagStore(api.qcFlag);
const qcRuleStore = new QCRuleStore(api.qcRule, qcTypeStore, qcFlagStore);
const unitStore = new UnitStore(api.unit);
const roleStore = new RoleStore(api.role);
const permissionStore = new PermissionStore(api.permission);
const stationPermissionStore = new StationPermissionStore(api.userPermission.station);
const stationFtpStore = new StationFtpStore(api.station.ftp);
const parameterPermissionStore = new ParameterPermissionStore(api.userPermission.parameter);
const rolePermissionStore = new RolePermissionStore(api.userPermission);
const stationStore = new StationStore(api.station);
const monitoringStore = new MonitoringStore(api.monitoring);
const folderStore = new FolderStore(api.folder, stationStore);
const dataOriginParameterStore = new DataOriginParameterStore(api.dataOriginParameter);
const dataOriginStore = new DataOriginStore(api.dataOrigin, stationStore, dataOriginParameterStore);
const uiStore = new UiStore();

const inventoryManufacturerStore = new InventoryManufacturerStore(api.inventoryManufacturer);
const inventoryProductStore = new InventoryProductStore(api.inventoryProduct);
const inventorySupplierStore = new InventorySupplierStore(api.inventorySupplier);
const inventoryItemStore = new InventoryItemStore(api.inventoryItem);
const inventoryPcategoryStore = new InventoryPcategoryStore(api.inventoryPcategory);

const mapStore = new MapStore(api.mapMarker);
const metaDataStore = new MetaDataStore(api.metaData);
const metaDataTemplateStore = new MetaDataTemplateStore(api.metaDataTemplate, metaDataStore);

const daqLocationStore = new DaqLocationStore(api.daqLocation);
const daqProcessorStore = new DaqProcessorStore(api.daqProcessor, daqLocationStore);
const dataSourceStore = new DataSourceStore(api.dataSource, dataOriginStore, daqProcessorStore);
const dataOriginParameterTemplateStore = new DataOriginParameterTemplateStore(api.dataOriginParameterTemplate);

const dataExportStore = new DataExportStore(api.dataDelivery.export);
const rawDataExportStore = new RawDataExportStore(api.dataDelivery.rawExport);

const parameterUnitStore = new ParameterUnitStore(api.parameterUnit);
const dataSeriesStore = new DataSeriesStore(api.dataSeries, parameterUnitStore);


const userStore = new UserStore(api.user);
const userPreferenceStore = new UserPreferenceStore(api.user_preference);

const tagStore = new TagStore(api.tag);
const parameterStore = new ParameterStore(api.parameter, tagStore);
const parameterTypeStore = new ParameterTypeStore(api.parameterType, parameterStore);

const ticketStatusStore = new TicketStatusStore(maintenanceApi.ticket.status);
const ticketReasonStore = new TicketReasonStore(maintenanceApi.ticket.reason);
const ticketActionStore = new TicketActionStore(maintenanceApi.ticket.action);

const workOrderStatusStore = new WorkOrderStatusStore(maintenanceApi.workOrder.status);
const priorityStore = new PriorityStore(maintenanceApi.workOrder.priority);
const maintenanceTypeStore = new MaintenanceTypeStore(maintenanceApi.workOrder.maintenanceType);

const hydrologyStore = new HydrologyStore(stationStore);
const transferStore = new TransferStore(api.transfer);
const hqcStore = new HQCStore();

const iDaqImageSourceStore = new IDaqImageSourceStore(idaqApi.imagesource);
const iDaqImageSourceDeviceStore = new IDaqImageSourceDeviceStore(idaqApi.imagesourceDevice);
const stationImageStore = new StationImageStore(idaqApi.image);
const imageStore = new ImageStore(idaqApi.image, stationStore);
const imageTagStore = new ImageTagStore(idaqApi.imagetag);
const systemStore = new SystemStore(sysConfigApi.system);
const hydroMeteoStore = new HydroMeteoStore(stationStore, mapStore);

const locationTypeStore = new LocationTypeStore(api.locationType);
const locationStore = new LocationStore(api.location);
const stationTypeStore = new StationTypeStore(api.stationType);
const reportingTemplateHeaderStore = new ReportingTemplateHeaderStore(api.reportingTemplateHeader);
const reportingTemplateStore = new ReportingTemplateStore(api.reportingTemplate, reportingTemplateHeaderStore);

const ratingEquationStore = new RatingEquationStore(api.ratingEquation);

const surveyTopicStore = new TopicStore(maintenanceApi.survey.topic);
const surveyTemplateStore = new TemplateStore(maintenanceApi.survey.template);
const surveyStore = new SurveyStore(maintenanceApi.survey.survey)

const eventTypeStore = new EventTypeStore(maintenanceApi.event.type);
const eventStore = new EventStore(maintenanceApi.event.event);

const ticketStore = new TicketStore({
  transportLayer: maintenanceApi.ticket.ticket,
  stationStore,
  ticketStatusStore,
  ticketReasonStore,
  ticketActionStore,
  userStore,
  locationStore
});

const workOrderStore = new WorkOrderStore({
  transportLayer: maintenanceApi.workOrder.workOrder,
  workOrderStatusStore,
  stationStore,
  priorityStore,
  maintenanceTypeStore,
  userStore,
  ticketStore,
  locationStore
});

const workOrderRouteStore = new WorkOrderRouteStore({
  workOrderStatusStore,
  priorityStore,
  maintenanceTypeStore,
  userStore,
  stationStore,
  workOrderStore
});
const serverStore = new ServerStore(sysConfigApi.server);
const idaqExportStore = new IdaqExportStore(api.dataDelivery.idaqExport);

const App = () => (
  <Provider
    aggregationStore={aggregationStore}
    daqLocationStore={daqLocationStore}
    dataOriginParameterStore={dataOriginParameterStore}
    dataOriginParameterTemplateStore={dataOriginParameterTemplateStore}
    dataOriginStore={dataOriginStore}
    dataSeriesStore={dataSeriesStore}
    dataSourceStore={dataSourceStore}
    daqProcessorStore={daqProcessorStore}
    folderStore={folderStore}
    inventoryManufacturerStore={inventoryManufacturerStore}
    inventorySupplierStore={inventorySupplierStore}
    inventoryProductStore={inventoryProductStore}
    inventoryItemStore={inventoryItemStore}
    inventoryPcategoryStore={inventoryPcategoryStore}
    mapStore={mapStore}
    metaDataStore={metaDataStore}
    metaDataTemplateStore={metaDataTemplateStore}
    monitoringStore={monitoringStore}
    parameterStore={parameterStore}
    parameterTypeStore={parameterTypeStore}
    parameterUnitStore={parameterUnitStore}
    permissionStore={permissionStore}
    qcCheckStore={qcCheckStore}
    qcRuleStore={qcRuleStore}
    qcFlagStore={qcFlagStore}
    qcTypeStore={qcTypeStore}
    requestStore={requestStore}
    roleStore={roleStore}
    stationStore={stationStore}
    stationFtpStore={stationFtpStore}
    uiStore={uiStore}
    unitStore={unitStore}
    userStore={userStore}
    userPreferenceStore={userPreferenceStore}
    tagStore={tagStore}
    parameterPermissionStore={parameterPermissionStore}
    stationPermissionStore={stationPermissionStore}
    rolePermissionStore={rolePermissionStore}

    ticketStore={ticketStore}
    ticketStatusStore={ticketStatusStore}
    ticketReasonStore={ticketReasonStore}
    ticketActionStore={ticketActionStore}

    workOrderStore={workOrderStore}
    workOrderRouteStore={workOrderRouteStore}
    workOrderStatusStore={workOrderStatusStore}
    priorityStore={priorityStore}
    maintenanceTypeStore={maintenanceTypeStore}

    dataExportStore={dataExportStore}
    rawDataExportStore={rawDataExportStore}
    idaqExportStore={idaqExportStore}

    hydrologyStore={hydrologyStore}
    transferStore={transferStore}
    hqcStore={hqcStore}
    imageSourceStore={iDaqImageSourceStore}
    imageSourceDeviceStore={iDaqImageSourceDeviceStore}
    stationImageStore={stationImageStore}
    imageStore={imageStore}
    imageTagStore={imageTagStore}
    systemStore={systemStore}

    hydroMeteoStore={hydroMeteoStore}
    locationTypeStore={locationTypeStore}
    locationStore={locationStore}
    stationTypeStore={stationTypeStore}
    reportingTemplateStore={reportingTemplateStore}
    reportingTemplateHeaderStore={reportingTemplateHeaderStore}

    ratingEquationStore={ratingEquationStore}

    surveyTopicStore={surveyTopicStore}
    surveyTemplateStore={surveyTemplateStore}
    surveyStore={surveyStore}

    eventTypeStore={eventTypeStore}
    eventStore={eventStore}

    serverStore={serverStore}
  >
    <Routes />
  </Provider>
);

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js